import { TransformInt } from '../../../shared/decorators/transform-int.decorator';

import { CreateTransactionDto } from './create-transaction.dto';

/**
 * Update transaction DTO
 */
export class UpdateTransactionDto extends CreateTransactionDto {
	@TransformInt()
	id!: number;
}
